import { Stack, Typography, styled, useTheme } from "@mui/material"
import { type ReactNode, useMemo } from "react"
import { Activity, Check, Clock } from "react-feather"

const Title = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(18),
  lineHeight: theme.typography.pxToRem(18),
}))

export const ICON_SIZE = "24px"
export const ProgressStatus = ({
  progress,
  title,
  color,
  showZero = false,
}: {
  progress: number
  title: ReactNode
  color: string
  /** When progress is 0, shows a 0 or a waiting status */
  showZero?: boolean
}) => {
  const { palette, typography } = useTheme()
  const statusIcon = useMemo(() => {
    switch (true) {
      case progress === 100:
        return <Check color={palette.success.main} size={ICON_SIZE} />
      case progress > 0:
        return <Activity color={palette.grey.light} size={ICON_SIZE} />
      default:
        return showZero ? (
          <Activity color={palette.grey.light} size={ICON_SIZE} />
        ) : (
          <Clock color={palette.grey.light} size={ICON_SIZE} />
        )
    }
  }, [progress, showZero, palette.grey.light, palette.success.main])

  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      {statusIcon}
      {progress === 0 && !showZero ? (
        <Typography
          fontSize={typography.pxToRem(18)}
          fontWeight={500}
          color={palette.grey.dark}
        >
          Attente&nbsp;participation
        </Typography>
      ) : (
        <Title color={color}>{title}</Title>
      )}
    </Stack>
  )
}
